export class EdgeSdkManager {
    _httpClient;
    _config;
    _trackingManager;
    _bucketingContent;
    _flagshipInstanceId;
    constructor({ httpClient, sdkConfig, trackingManager, flagshipInstanceId }) {
        this._httpClient = httpClient;
        this._config = sdkConfig;
        this._trackingManager = trackingManager;
        this._bucketingContent = sdkConfig.initialBucketing;
        this._flagshipInstanceId = flagshipInstanceId;
    }
    resetSdk() {
        //
    }
    getBucketingContent() {
        return this._bucketingContent;
    }
    async initSdk() {
        //
    }
    getEAIConfig() {
        return undefined;
    }
}
